var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterStroke = function SvgFilterStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.448184 1.35097C0.707428 0.825239 1.27075 0.666504 1.74355 0.666504H12.2565C12.7304 0.666504 13.2941 0.825884 13.5526 1.35271C13.8064 1.8698 13.6015 2.40886 13.3242 2.78803L9.33329 8.54174V12.8198C9.33329 13.1645 9.21005 13.4897 9.04113 13.7456C8.87272 14.0006 8.62137 14.2432 8.30109 14.375L6.20608 15.2368C5.87813 15.3717 5.4754 15.3837 5.13588 15.1493C4.79981 14.9173 4.66662 14.5411 4.66662 14.1924V8.54174L0.675855 2.78804C0.397862 2.40796 0.193123 1.86821 0.448184 1.35097ZM1.75127 1.99984C1.75235 2.00132 1.75344 2.00281 1.75455 2.00431C1.75853 2.00969 1.76243 2.01513 1.76625 2.02064L5.88109 7.95322C5.95848 8.06481 5.99996 8.19737 5.99996 8.33317V13.8798L7.79384 13.1419C7.81425 13.1335 7.87248 13.0957 7.92848 13.0109C7.98396 12.9268 7.99996 12.8529 7.99996 12.8198V8.33317C7.99996 8.19737 8.04143 8.0648 8.11883 7.95321L12.2338 2.02063C12.2376 2.01513 12.2415 2.00969 12.2455 2.00431C12.2466 2.00281 12.2477 2.00132 12.2487 1.99984H1.75127Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-stroke.0e871066.svg";
export { ForwardRef as ReactComponent };